import axios from 'axios';

const getErrorMessage = (response) => {
  const errors = response && response.data && Array.isArray(response.data.errors)
    ? response.data.errors
    : [];

  if (errors.length > 0 && errors[0].message) {
    return errors[0].message;
  }

  return 'Не удалось загрузить историю бонусов';
};

export default {
  state: {
    bonusHistory: [],
    bonusHistoryLoading: false,
    bonusHistoryError: null,
    bonusHistoryLoaded: false,
    noMoreBonusHistory: false,
    bonusHistoryCurrentPage: 0,
    bonusHistoryLoadedPages: {},
    bonusHistoryRequestVersion: 0,
  },
  mutations: {
    SET_BONUS_HISTORY(state, {items, pagination, page, requestVersion}) {
      if (state.bonusHistoryRequestVersion !== requestVersion) {
        return;
      }

      const uniqueItems = [];
      const knownIds = new Set(page > 1 ? state.bonusHistory.map(item => item.id) : []);

      items.forEach((item) => {
        if (!knownIds.has(item.id)) {
          knownIds.add(item.id);
          uniqueItems.push(item);
        }
      });

      state.bonusHistory = page > 1
        ? state.bonusHistory.concat(uniqueItems)
        : uniqueItems;
      state.bonusHistoryLoadedPages = {
        ...state.bonusHistoryLoadedPages,
        [page]: true,
      };
      state.bonusHistoryCurrentPage = pagination.current_page || page;
      state.noMoreBonusHistory = pagination.has_next !== true;
      state.bonusHistoryLoaded = true;
    },
    SET_BONUS_HISTORY_LOADING(state, {status, requestVersion}) {
      if (state.bonusHistoryRequestVersion !== requestVersion) {
        return;
      }

      state.bonusHistoryLoading = status;
    },
    SET_BONUS_HISTORY_ERROR(state, {error, requestVersion}) {
      if (state.bonusHistoryRequestVersion !== requestVersion) {
        return;
      }

      state.bonusHistoryError = error;
    },
    UNSET_BONUS_HISTORY(state) {
      state.bonusHistoryRequestVersion += 1;
      state.bonusHistory = [];
      state.bonusHistoryLoading = false;
      state.bonusHistoryError = null;
      state.bonusHistoryLoaded = false;
      state.noMoreBonusHistory = false;
      state.bonusHistoryCurrentPage = 0;
      state.bonusHistoryLoadedPages = {};
    },
  },
  actions: {
    async fetchBonusHistory({commit, state}, {page}) {
      const requestedPage = Math.max(1, Number.parseInt(page, 10) || 1);

      if (requestedPage === 1) {
        commit('UNSET_BONUS_HISTORY');
      }

      if (state.bonusHistoryLoading || state.bonusHistoryLoadedPages[requestedPage]) {
        return false;
      }
      if (requestedPage > 1 && state.noMoreBonusHistory) {
        return false;
      }

      const requestVersion = state.bonusHistoryRequestVersion;

      commit('SET_BONUS_HISTORY_LOADING', {status: true, requestVersion});
      commit('SET_BONUS_HISTORY_ERROR', {error: null, requestVersion});

      try {
        const response = await axios.get('api/bonus-history/', {
          params: {page: requestedPage},
        });

        if (!response.data || response.data.status !== 'success') {
          throw new Error(getErrorMessage(response));
        }

        const data = response.data.data;
        if (!data || !Array.isArray(data.items) || !data.pagination) {
          throw new Error('Некорректный ответ сервера');
        }

        commit('SET_BONUS_HISTORY', {
          items: data.items,
          pagination: data.pagination,
          page: requestedPage,
          requestVersion,
        });

        return true;
      } catch (error) {
        const errorMessage = error && error.response
          ? getErrorMessage(error.response)
          : (error && error.message ? error.message : 'Не удалось загрузить историю бонусов');

        commit('SET_BONUS_HISTORY_ERROR', {error: errorMessage, requestVersion});
        return false;
      } finally {
        commit('SET_BONUS_HISTORY_LOADING', {status: false, requestVersion});
      }
    },
  },
  getters: {
    bonusHistory: state => state.bonusHistory,
    bonusHistoryLoading: state => state.bonusHistoryLoading,
    bonusHistoryError: state => state.bonusHistoryError,
    bonusHistoryLoaded: state => state.bonusHistoryLoaded,
    noMoreBonusHistory: state => state.noMoreBonusHistory,
    bonusHistoryCurrentPage: state => state.bonusHistoryCurrentPage,
  },
};
